import { makeByIdsDictionarySelector } from 'store/state/domainData/selectors/common';
import { makeMapStateToPropsFactory } from 'components/cards/listing/makeMapStateToPropsFactory';
import { State } from 'store/state';
import { IBulletin, ICommercialBulletin, PoiId, ResolutionPreference } from 'utils/entities';
import { UniversalCardProps } from 'components/cards/listing/UniversalCard/UniversalCard';
import UniversalCard  from 'components/cards/listing/UniversalCard';
import { connect } from 'react-redux';
import React from 'react';
import Carousel from 'ds/components/carousels/carousel';
import { ItemWrapper } from 'ds/components/carousels/carousel/styled';
import { getLinkRouteParams } from 'ds/components/carousels/carousel/utils';
import { ShowAt } from 'consts/breakpoints';
import { routeSelector } from 'store/state/selectors/router';
import { Route, State as RouteState } from 'config/routes';
import { isLoadingListingSearchListSelector } from 'store/state/domainData/selectors';
import { ScrollBox } from 'ds/components/carousels/scroll-box';
import { routeByPoiType } from 'utils/marketplaceRoutes';
import { Link } from 'components/link';
import { searchBulletinsByMarketplaceSelector } from 'store/state/selectors/bulletins';
import { CardType } from 'components/cards/types';

interface ListingCarouselProps {
  // not Array<IBulletin> | Array<ICommercialBulletin> because of a bug in typescript 3.6.3 version - it can't handle map(). Allegedly fixed in typescript 4.3
  listings: Array<IBulletin | ICommercialBulletin>;
  isLoadingListings: boolean;
  route: RouteState;
}

const listingsByIdsSelector = makeByIdsDictionarySelector(searchBulletinsByMarketplaceSelector);
const poiByIdsSelector: any = (state: State, poiId: PoiId) => listingsByIdsSelector(state)[poiId];

const makeMapStateToProps = makeMapStateToPropsFactory(poiByIdsSelector);

const SpecificUniversalCard = (props: UniversalCardProps) => {
  let enhancedProps: UniversalCardProps = {
    ...props,
    hideLogoPreview: true,
    isMinHeight: true,
  };
  if (enhancedProps.cardType === CardType.Bulletin || enhancedProps.cardType === CardType.CommercialBulletin) {
    enhancedProps = {
      ...enhancedProps,
      resolutionPreferences: ResolutionPreference.Neighborhood,
    };
  }
  return <UniversalCard {...enhancedProps} />;
};
const ConnectedUniversalCard = connect(makeMapStateToProps)(SpecificUniversalCard);

const KEY = Symbol('listingsListCarousel');

function getSource(routeName: Route) {
  if (routeName === Route.Sold) return 'sold_page';
  return null;
}

export const ListingCarousel: React.FC<ListingCarouselProps> = ({ listings, isLoadingListings, route }) => {
  if (!listings) return null;

  const hasArrows = listings.length > 2;

  const listingsList = listings.map(({ id, type }) => (
    <ItemWrapper key={id}>
      <Link
        routeName={routeByPoiType(type)}
        routeParams={getLinkRouteParams(id, route.params, getSource(route.name))}
        hideLinkParams
      >
        <ConnectedUniversalCard
          id={id}
          emptyLazyLoadPlaceholder
        />
      </Link>
    </ItemWrapper>
  ));

  return (
    <>
      <ShowAt to={2}>
        <ScrollBox cacheKey={KEY} autoWidth>
          {listingsList}
        </ScrollBox>
      </ShowAt>
      <ShowAt from={3}>
        <Carousel
          isLoading={isLoadingListings}
          hasArrows={hasArrows}
        >
          {listingsList}
        </Carousel>
      </ShowAt>
    </>
  );
};

const mapStateToProps = (state: State) => ({
  listings: searchBulletinsByMarketplaceSelector(state),
  isLoadingListings: isLoadingListingSearchListSelector(state),
  route: routeSelector(state),
});

export default connect(mapStateToProps, null)(ListingCarousel);
